export default "__VITE_ASSET__BFQCBdC5__"